export default __webpack_public_path__ + "static/media/deshidratacion.91b443f4.pdf";